import { render, staticRenderFns } from "./individualSales.vue?vue&type=template&id=37172db2&scoped=true"
import script from "./individualSales.vue?vue&type=script&lang=js"
export * from "./individualSales.vue?vue&type=script&lang=js"
import style0 from "./individualSales.vue?vue&type=style&index=0&id=37172db2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37172db2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37172db2')) {
      api.createRecord('37172db2', component.options)
    } else {
      api.reload('37172db2', component.options)
    }
    module.hot.accept("./individualSales.vue?vue&type=template&id=37172db2&scoped=true", function () {
      api.rerender('37172db2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reportCenter/individualSales.vue"
export default component.exports